import {
  AbsoluteCenter,
  Box,
  chakra,
  Flex,
  Image,
  shouldForwardProp,
  Text,
} from "@chakra-ui/react";
import { isValidMotionProp, motion } from "framer-motion";
import React from "react";
import { useTranslation } from "react-i18next";
import { COMMON_WEB_PATH } from "../../constant";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { HIDE_MAINTAIN_ALERT } from "../../redux/action/member/memberAction";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const CommonAlertModal = ({
  openModal,
  setOpenModal,
  content,
  params,
  priorityContent,
}) => {
  const { t } = useTranslation();
  const i18n_common = (key, props) => t(`common.${key}`, { ...props });

  const dispatch = useDispatch();
  const isMaintainAlert = useSelector((state) => state.isMaintainAlert);

  const handleConfirm = () => {
    setOpenModal(false);
  };

  return (
    openModal && (
      <Flex
        position="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg="rgba(0, 0, 0, 0.8)"
        zIndex="99999"
        backdropFilter="blur(2px)"
        justifyContent="center"
        alignItems="center"
      >
        <ChakraBox
          as={Flex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.3 }}
          w="420px"
          minH="300px"
          bgImage={`url('${COMMON_WEB_PATH}/now888/modal/hintBG.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          position={"relative"}
          p={6}
          pt={"50px"}
        >
          <AbsoluteCenter
            display="flex"
            fontSize="24px"
            color="white"
            textAlign="center"
            mt={4}
            // bgImage={`url('${COMMON_WEB_PATH}/flyDragon/hintTitleBG.webp')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            sx={{ width: "-webkit-fill-available" }}
            justifyContent="center"
            alignItems="center"
            top="-30px"
          >
            <Image
              src={`${COMMON_WEB_PATH}/now888/modal/hintWORD${
                i18next.language == "tw" ? "" : `_${i18next.language}`
              }.webp`}
              height={{
                base: "50px",
                xl: "60px",
              }}
            />
          </AbsoluteCenter>
          {/* 隱形XX */}
          <Box
            position="absolute"
            top="0"
            right="0"
            w="60px"
            h="30px"
            onClick={handleConfirm}
            cursor="pointer"
          ></Box>
          <Box
            flex={1}
            alignItems={"center"}
            fontSize="24px"
            fontWeight={"bold"}
            color="white"
            textAlign="center"
            display="flex"
            mb={2}
          >
            <Text>
              {priorityContent || i18n_common(content, { ...params })}
            </Text>
          </Box>

          <Flex
            gap={4}
            mt={3}
            mb={3}
            justifyContent="center"
            alignItems="center"
          >
            <Flex
              as="button"
              w="165px"
              h="60px"
              bgImage={`url('${COMMON_WEB_PATH}/now888/button/confirm_background.png')`}
              bgPosition="center"
              bgRepeat="no-repeat"
              bgSize="100% 100%"
              justifyContent="center"
              alignItems="center"
              onClick={handleConfirm}
              cursor={"pointer"}
            >
              <Image
                src={`${COMMON_WEB_PATH}/now888/button${
                  i18next.language == "tw" ? "" : `/${i18next.language}`
                }/confirm_text.png`}
                width="70px"
                height={{
                  base: "30px",
                  xl: "30px",
                }}
              />
            </Flex>
          </Flex>
        </ChakraBox>
      </Flex>
    )
  );
};

export default CommonAlertModal;
